<div [formGroup]="form" class="timeslot-form">

    <cyno-field class="timeslot-form__field">
        <cyno-label>Welke dag komt u het uit?</cyno-label>
        <cyno-datepicker formControlName="datum" id="datum"></cyno-datepicker>
    </cyno-field>

    <div class="form-group" *ngIf="loading">
        <div class="control-label">Kies tijdslot</div>
        <div class="control-input">We bladeren even in de agenda...</div>
    </div>

    <ng-container *ngIf="timeSlots.length > 0">
        <cyno-field class="form-group-radio">
            <cyno-label>Beschikbare tijdstippen</cyno-label>
            <select cynoSelect formControlName="tijdstip">
                <ng-container *ngFor="let tijdslot of timeSlots">
                    <option cynoOption value="{{tijdslot.event_time}}">{{tijdslot.date_time}}</option>
                </ng-container>
            </select>
        </cyno-field>
    </ng-container>

    <cyno-alert [notifications]="notifications" *ngIf="notifications"></cyno-alert>
</div>
